import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
    MainFilters,
    MainFiltersParams,
} from 'components/main-filters/main-filters';
import { ConversionFilterForm } from 'features/cms/components/conversion-filter-form/conversion-filter-form';
import { AddCurrencyConversionModal } from 'features/cms/components/currency-conversion/Add-currency-conversion-madal/add-currency-conversion-modal';
import { CurrencyConversionTabel } from 'features/cms/components/currency-conversion/currency-conversion-tabel';
import { CurrencyFilterFormPaginated, CurrencyFilterFormValues } from 'features/cms/components/currency-filter-form';
import { useGetConversionCurrency } from 'features/cms/use-cases/get-coversion-currency';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const { useBreakpoint } = Grid;

const initialFilterValues: any = {
    CurrencyName: undefined,
};

export const CurrencyConversionView = () => {
    const screens = useBreakpoint();
    const permissions = usePermissions();
    const { params, updateParams, resetPage } =
        usePaginationParams<CurrencyFilterFormPaginated>({
            page: 1,
            size: 10,
            // order_by: '',
            ...initialFilterValues,
        });

    const { data, isFetching, refetch } = useGetConversionCurrency(params, { retry: false });
    const [currencyEditData, setCurrencyEditData] = useState<any>(undefined);

    const shouldHandleFieldCreation = permissions?.fields.add;

    const handleFiltersChange = (values: CurrencyFilterFormValues) => {
        updateParams(values);
        resetPage();
        refetch();
    };

    const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
        updateParams(mainParams);
        resetPage();
    };
    const [showCurrencyModal, setShowCurrencyModal] = useState(false);
    const formId = 'events-filters-form';

    const handleCloseModal = () => {
        setShowCurrencyModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = () => {
        setShowCurrencyModal(true);
        document.body.style.overflow = 'hidden';
    }

    return (
        <>
            <ContentTopBar
                title={"Currency Conversion"}
                renderHeadingContent={
                    <MainFilters onChange={handleMainFiltersChange} />
                }
                renderButtons={
                    <>
                        {shouldHandleFieldCreation ? (
                            <>
                                <Button
                                    icon={!screens.xs ? <PlusOutlined /> : undefined}
                                    onClick={handleOpenModal}
                                    type='primary'
                                >
                                    {"Add Currency Conversion"}
                                </Button>
                                <div className={`cstmrightmdl ${showCurrencyModal && "show"}`}>
                                    <AddCurrencyConversionModal showCurrencyModal={showCurrencyModal} refetch={refetch} onClose={handleCloseModal} currencyEditData={currencyEditData} />

                                </div>

                            </>
                        ) : null}
                    </>
                }
            />

            <ContentFilters formId={formId}>
                <ConversionFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange}
                    initialValues={initialFilterValues}
                />
            </ContentFilters>

            <CurrencyConversionTabel
                data={data}
                isLoading={isFetching}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}
                currencyEditData={currencyEditData}
                setCurrencyEditData={setCurrencyEditData}
            />
            <Outlet />
        </>
    );
};


